var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 8.125C3.125 5.76798 3.125 4.58947 3.85723 3.85723C4.58947 3.125 5.76798 3.125 8.125 3.125C10.482 3.125 11.6605 3.125 12.3928 3.85723C13.125 4.58947 13.125 5.76798 13.125 8.125C13.125 10.482 13.125 11.6605 12.3928 12.3928C11.6605 13.125 10.482 13.125 8.125 13.125C5.76798 13.125 4.58947 13.125 3.85723 12.3928C3.125 11.6605 3.125 10.482 3.125 8.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 21.875C16.875 19.518 16.875 18.3395 17.6072 17.6072C18.3395 16.875 19.518 16.875 21.875 16.875C24.232 16.875 25.4105 16.875 26.1428 17.6072C26.875 18.3395 26.875 19.518 26.875 21.875C26.875 24.232 26.875 25.4105 26.1428 26.1428C25.4105 26.875 24.232 26.875 21.875 26.875C19.518 26.875 18.3395 26.875 17.6072 26.1428C16.875 25.4105 16.875 24.232 16.875 21.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 21.875C3.125 19.518 3.125 18.3395 3.85723 17.6072C4.58947 16.875 5.76798 16.875 8.125 16.875C10.482 16.875 11.6605 16.875 12.3928 17.6072C13.125 18.3395 13.125 19.518 13.125 21.875C13.125 24.232 13.125 25.4105 12.3928 26.1428C11.6605 26.875 10.482 26.875 8.125 26.875C5.76798 26.875 4.58947 26.875 3.85723 26.1428C3.125 25.4105 3.125 24.232 3.125 21.875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.125C16.875 5.76798 16.875 4.58947 17.6072 3.85723C18.3395 3.125 19.518 3.125 21.875 3.125C24.232 3.125 25.4105 3.125 26.1428 3.85723C26.875 4.58947 26.875 5.76798 26.875 8.125C26.875 10.482 26.875 11.6605 26.1428 12.3928C25.4105 13.125 24.232 13.125 21.875 13.125C19.518 13.125 18.3395 13.125 17.6072 12.3928C16.875 11.6605 16.875 10.482 16.875 8.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashA);
export default __webpack_public_path__ + "static/media/dashA.1a71f9f7648b477c98f7602b139ba1bb.svg";
export { ForwardRef as ReactComponent };